module.exports = __webpack_public_path__ + "img/PART-B-mobile-02.95ea00bd.png";